/** A five-point star in currentColor, so it takes the colour of whatever it sits in. Decorative. */
export function StarIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 2.2l2.95 6.27 6.85.83-5.05 4.72 1.33 6.78L12 17.4l-6.08 3.4 1.33-6.78L2.2 9.3l6.85-.83z"
      />
    </svg>
  );
}
